export function init() {
    const $form = document.querySelector('.js-mailchimp-container');
    submitMailchimpListener($form);
}

function submitMailchimpListener($form) {
    const mailchimpForm = $form.querySelector('.js-mailchimp-form'),
        formSubmit = mailchimpForm.querySelector('.js-form-submit'),
        responseMessage = document.querySelector('.js-mailchimp-form-response');

    // On form Submission send over AJAX request
    if (window.fetch) {
        mailchimpForm.addEventListener('submit', e => {
            e.preventDefault();

            // Send form data for processing
            const formData = new FormData(mailchimpForm),
                serializedData = Array.from(formData, x =>
                    x.map(encodeURIComponent).join('=')
                ).join('&');

            // Show loader
            $form.classList.add('loading');

            responseMessage.classList.remove('show');

            // Make post request
            fetch('/mailchimp/send', {
                method: 'POST',
                body: new URLSearchParams(serializedData),
                headers: {
                    Accept: 'application/json',
                },
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                // Hide loader
                $form.classList.remove('loading');

                if (data.success) {
                    responseMessage.classList.remove('error');
                } else {
                    responseMessage.classList.add('error');
                }

                if (data.msg == "Mailchimp error: Member Exists") {
                    responseMessage.textContent = "It looks like you have already subscribed to our newsletter!";
                } else {
                    responseMessage.textContent = data.msg;
                }

                responseMessage.classList.add('show');

                if (data.success) {
                    mailchimpForm.reset();
                    // setTimeout(function() {
                    //     globalHeader.closeMailchimp();
                    // }, 5000);

                    const formValues = data.values;

                    // Identify user with a GoSquared Profile
                    if (typeof _gs !== 'undefined') {
                        _gs('identify', {
                            first_name: formValues.merge_fields.FNAME,
                            last_name: formValues.merge_fields.LNAME,
                            email: formValues.email
                        });
                    }
                }
            });
        });
    }
}
